module.exports = __webpack_public_path__ + "assets/Hospitality.866751d4.svg";